let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5UUJZ")).then(() => parcelRequire('69tQw'));